"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { Tag } from "@/stores/templatesStore";
type SidebarTag = Pick<Tag, "name" | "slug">;
interface TemplateCategoryBarProps {
  selectedTagSlug: string | null;
  onTagChange: (slug: string | null) => void;
  tags: SidebarTag[];
}
export function TemplateCategoryBar(t0) {
  const $ = _c(19);
  const {
    selectedTagSlug,
    onTagChange,
    tags
  } = t0;
  const getButtonClassName = _temp;
  const t1 = selectedTagSlug === null ? "brand" : "white";
  let t2;
  if ($[0] !== onTagChange) {
    t2 = () => onTagChange(null);
    $[0] = onTagChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = selectedTagSlug === null;
  const t4 = selectedTagSlug === null;
  let t5;
  if ($[2] !== t4) {
    t5 = getButtonClassName(t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t5) {
    t6 = <Button type="button" size="lg" variant={t1} onClick={t2} aria-pressed={t3} className={t5}>All Use Cases</Button>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onTagChange || $[10] !== selectedTagSlug || $[11] !== tags) {
    let t8;
    if ($[13] !== onTagChange || $[14] !== selectedTagSlug) {
      t8 = tag => {
        const isActive_0 = selectedTagSlug === tag.slug;
        return <Button key={tag.slug} type="button" size="lg" variant={isActive_0 ? "brand" : "white"} onClick={() => onTagChange(tag.slug)} aria-pressed={isActive_0} className={getButtonClassName(isActive_0)}>{tag.name}</Button>;
      };
      $[13] = onTagChange;
      $[14] = selectedTagSlug;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    t7 = tags.map(t8);
    $[9] = onTagChange;
    $[10] = selectedTagSlug;
    $[11] = tags;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <nav className="mb-6 grid grid-cols-2 gap-2.5 md:hidden" aria-label="Template categories">{t6}{t7}</nav>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
function _temp(isActive) {
  return cn("w-full rounded-ds-md px-3 text-sm", !isActive && "!text-ds-neutral-800 before:!from-ds-neutral-100 before:!to-ds-neutral-200 dark:!text-ds-neutral-800");
}